import { Box, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import DownIcon from '@material-ui/icons/ArrowDownward';
import UpIcon from '@material-ui/icons/ArrowUpward';
import cx from 'clsx';
import Number from 'components/Number';
import PropTypes from 'prop-types';
import React from 'react';
import CountUp from 'react-countup';

const styles = makeStyles(({ palette, spacing }) => ({
    root: {
        padding: spacing(2),
        background: 'transparent',
    },
    icon: {
        marginRight: spacing(1),
    },
    up: {
        color: palette.success.main,
    },
    down: {
        color: palette.primary.main,
    },
}));

const propTypes = { label: PropTypes.string.isRequired };
const defaultProps = {};

function renderIcon(item) {
    const classes = styles();
    const today = parseInt(item.today, 0);
    const yesterday = parseInt(item.yesterday, 0);

    if (today < yesterday) {
        return <DownIcon fontSize="small" className={cx(classes.down, classes.icon)} color="primary" />;
    }
    if (today === yesterday) {
        return <div />;
    }
    return <UpIcon fontSize="small" className={cx(classes.up, classes.icon)} />;
}

function HeaderBox({ label, item, boxStyle }) {
    const classes = styles();
    let percentage = ((parseInt(item.today, 0) - parseInt(item.yesterday, 0)) / parseInt(item.yesterday, 0)) * 100;

    percentage = !isFinite(percentage) ? 0 : isNaN(percentage) ? 0 : Math.floor(percentage);

    return (
        <Paper elevation={0} className={classes.root} style={boxStyle}>

            <Grid container flexDirection="column">
                <Grid md={12} xs={12} item>
                    <Typography variant="subtitle2" component="div">
                        <Box letterSpacing={1}>
                            {label}
                        </Box>
                    </Typography>
                    <Typography variant="h4" color="inherit">
                        <CountUp
                            useEasing
                            start={0}
                            end={item.today}
                            duration={2.75}
                            separator="."
                        />
                    </Typography>

                </Grid>

                <Grid md={12} xs={12} item>
                    <Box display="flex" alignItems="center">
                        {renderIcon(item)}

                        <Typography variant="overline">
                            {`${percentage}% from yesterday (`}
                            <Number disabledTypography value={Math.floor(item.yesterday)} />
                            )
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
}

HeaderBox.propTypes = propTypes;
HeaderBox.defaultProps = defaultProps;

export default HeaderBox;
